export default __webpack_public_path__ + "static/media/people-laughing.400604f3.png";